import { useAnimatedNumber } from '../hooks/useAnimatedNumber.js';
import { formatPercent } from '../utils/format.js';
import PropTypes from 'prop-types';

export default function DonutChart({ netPercent = 0, taxPercent = 0 }) {
  const animatedNet = useAnimatedNumber(netPercent, 800);
  const animatedTax = useAnimatedNumber(taxPercent, 800);

  const r = 70;
  const cx = 90;
  const cy = 90;
  const stroke = 16;
  const circumference = 2 * Math.PI * r;

  const netDash = (animatedNet / 100) * circumference;
  const taxDash = (animatedTax / 100) * circumference;

  return (
    <div className="donut-chart">
      <svg viewBox="0 0 180 180" className="donut-chart__svg" aria-label={`Net pay: ${formatPercent(netPercent)}, Tax: ${formatPercent(taxPercent)}`}>
        {/* Background ring */}
        <circle cx={cx} cy={cy} r={r} fill="none" stroke="rgba(255,255,255,0.06)" strokeWidth={stroke} />

        {/* Tax arc (red) */}
        <circle
          cx={cx} cy={cy} r={r}
          fill="none"
          stroke="rgba(255,85,85,0.85)"
          strokeWidth={stroke}
          strokeDasharray={`${taxDash} ${circumference - taxDash}`}
          strokeDashoffset={0}
          strokeLinecap="round"
          style={{ transition: 'stroke-dasharray 0.8s cubic-bezier(0.34,1.56,0.64,1)', transform: 'rotate(-90deg)', transformOrigin: `${cx}px ${cy}px` }}
        />

        {/* Net arc (gold-green) */}
        <circle
          cx={cx} cy={cy} r={r}
          fill="none"
          stroke="#c9a440"
          strokeWidth={stroke}
          strokeDasharray={`${netDash} ${circumference - netDash}`}
          strokeDashoffset={-(taxDash)}
          strokeLinecap="round"
          style={{ transition: 'stroke-dasharray 0.8s cubic-bezier(0.34,1.56,0.64,1), stroke-dashoffset 0.8s cubic-bezier(0.34,1.56,0.64,1)', transform: 'rotate(-90deg)', transformOrigin: `${cx}px ${cy}px` }}
        />

        {/* Center text */}
        <text x={cx} y={cy - 8} textAnchor="middle" className="donut-chart__pct" fill="#c9a440">
          {Math.round(animatedNet)}%
        </text>
        <text x={cx} y={cy + 12} textAnchor="middle" className="donut-chart__label" fill="rgba(255,255,255,0.5)">
          take-home
        </text>
      </svg>

      <div className="donut-chart__legend">
        <div className="donut-chart__legend-item">
          <span className="donut-chart__legend-dot" style={{ background: '#c9a440' }} />
          <span>Net Pay</span>
          <strong>{formatPercent(netPercent)}</strong>
        </div>
        <div className="donut-chart__legend-item">
          <span className="donut-chart__legend-dot" style={{ background: 'rgba(255,85,85,0.85)' }} />
          <span>Total Tax</span>
          <strong>{formatPercent(taxPercent)}</strong>
        </div>
      </div>
    </div>
  );
}

DonutChart.propTypes = {
  netPercent: PropTypes.number,
  taxPercent: PropTypes.number,
}

DonutChart.defaultProps = {
  netPercent: 0,
  taxPercent: 0,
}